import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/unidades/getUnidad.php';

export default function getUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}